import { PeriscopeField } from '.';
import { usePeriscopeActions } from '@hooks';
import { PeriscopeSfField, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';

export interface PeriscopeFieldRowProps {
	field: PeriscopeSfField;
	parentIndex: number;
	showParents?: boolean;
	source?: string;
	useApiNames: boolean;
}

export const PeriscopeFieldRow: React.FC<PeriscopeFieldRowProps> = ({
	field,
	parentIndex,
	showParents,
	source,
	useApiNames
}) => {
	const { openPeriscope } = usePeriscopeActions();

	const handleFieldClick = useCallback(
		(item: PeriscopeSfField) => {
			const { displayName, sonarObjectId } = item;

			openPeriscope({
				id: sonarObjectId,
				name: displayName,
				openedFromIndex: parentIndex,
				type: SonarObjectType.SalesforceField
			});
		},
		[ openPeriscope, parentIndex ]
	);

	const handleParentClick = useCallback(
		(item: PeriscopeSfField) => {
			const { parentDisplayName, parentSonarObjectId } = item;

			openPeriscope({
				id: parentSonarObjectId,
				name: parentDisplayName,
				openedFromIndex: parentIndex,
				type: SonarObjectType.SalesforceEntity
			});
		},
		[ openPeriscope, parentIndex ]
	);

	return (
		<PeriscopeField
			field={ field }
			key={ field.sonarObjectId }
			onFieldClick={ handleFieldClick }
			onParentClick={ handleParentClick }
			showParent={ showParents }
			source={ source }
			useApiName={ useApiNames } />
	);
};
